import InterfaceActions from './InterfaceActions.js';
import AllowedReducer from '../AllowedReducer.js';
class Can {
  constructor(path, isRoot, isGroup) {
    this.path = path;
    this.isRoot = isRoot;
    this.isGroup = isGroup;
  }

  /**
   * api call to check if you can create a device of the provided type
   * @returns {function} redux thunk function 
   */
  create(query, body) {
    if (body?.id) {
      return InterfaceActions.canAdd(this.path, query, body);
    }
    return InterfaceActions.canCreate(this.path, query, body);
  }
  get(query) {
    if (this.isRoot) {
      return async () => ({
        allowed: true
      });
    }
    return InterfaceActions.canGet(this.path, query);
  }

  /**
   * api call to check if you can update a device of the provided type
   * @returns {function} redux thunk function 
   */
  update(query, body) {
    if (this.isGroup) {
      return async () => {};
    }
    return InterfaceActions.canUpdate(this.path, query, body);
  }

  /**
   * api call to check if you can delete a device of the provided type
   * @returns {function} redux thunk function 
   */
  delete(query, body) {
    if (this.isGroup) {
      return async () => {};
    }
    if (body?.deleteDevice === 'force') {
      return InterfaceActions.canDelete(this.path, query, body);
    }
    return InterfaceActions.canRemove(this.path, query, body);
  }

  /**
   * checks if can list, at root level anyone can list, so do nothing
   */
  list(query) {
    if (this.isRoot) {
      return async () => ({
        allowed: true
      });
    }
    return InterfaceActions.canList(this.path, query);
  }

  /**
   * api call to check if you can get history
   * @returns {function} redux thunk function 
   */
  history(query) {
    if (this.isRoot) {
      return async () => ({
        allowed: true
      });
    }
    return InterfaceActions.canGetHistory(this.path, query);
  }

  /**
   * api call to check if you can get events
   * @returns {function} redux thunk function 
   */
  events(query) {
    if (this.isRoot) {
      return async () => ({
        allowed: true
      });
    }
    return InterfaceActions.canGetEvents(this.path, query);
  }

  /**
   * api call to check if you can look up a device by network alias
   * @returns {function} redux thunk function 
   */
  getDeviceByNetworkAlias(query) {
    return InterfaceActions.canGetDeviceByNetworkAlias(this.path, query);
  }
  sendOutboundDeviceMessage(query, body) {
    if (this.isGroup) {
      return async () => {};
    }
    return InterfaceActions.canSendOutboundDeviceMessage(this.path, query, body);
  }

  // ***** ACCESSORS *****

  getCan(state) {
    return AllowedReducer.get(state, this.path);
  }
  getCreate(state, opts) {
    if (opts?.id) {
      return this.getCan(state)?.add;
    }
    return this.getCan(state)?.create;
  }
  getGet(state) {
    if (this.isRoot) {
      return true;
    }
    return this.getCan(state)?.get;
  }
  getUpdate(state) {
    return this.getCan(state)?.update;
  }
  getDelete(state, opts) {
    if (opts?.deleteDevice === 'force') {
      return this.getCan(state)?.delete;
    }
    return this.getCan(state)?.remove;
  }

  /**
   * anyone can list at the root interfae level, the results might just be empty
   */
  getList(state) {
    if (this.isRoot) {
      return true;
    }
    return this.getCan(state)?.get;
  }
  getHistory(state) {
    if (this.isRoot) {
      return true;
    }
    return this.getCan(state)?.getHistory;
  }
  getEvents(state) {
    if (this.isRoot) {
      return true;
    }
    return this.getCan(state)?.getEvents;
  }
  getGetDeviceByNetworkAlias(state) {
    return this.getCan(state)?.getDeviceByNetworkAlias;
  }
  getSendOutboundDeviceMessage(state) {
    return this.getCan(state)?.sendOutboundDeviceMessage;
  }
}
Can.create = (path, isRoot, isGroup) => {
  return new Can(path, isRoot, isGroup);
};
export default Can;